import {
  WOOD_INVENTORY_ENTITY,
  archiveWoodInventoryItem,
  createWoodInventoryItem,
  restoreWoodInventoryItem,
  updateWoodInventoryItem
} from './wood-inventory.js';

export function createWoodInventoryLocalService({
  repository,
  queue,
  userId,
  now=()=>new Date().toISOString()
}={}){
  if(!repository?.get||!repository?.put||!repository?.list)throw new TypeError('repository with get/put/list is required');
  if(!queue?.enqueue)throw new TypeError('sync queue is required');
  const owner=String(userId||'').trim();
  if(!owner)throw new TypeError('userId is required');

  function assertOwner(item){
    if(item?.userId!==owner)throw new Error('WOOD_INVENTORY_OWNER_MISMATCH');
    return item;
  }

  async function create(input={}){
    const timestamp=now();
    const item=createWoodInventoryItem({...input,userId:owner,now:timestamp,createdAt:timestamp,updatedAt:timestamp});
    return queue.enqueue(WOOD_INVENTORY_ENTITY,item,'create');
  }

  async function get(id){
    const row=await repository.get(WOOD_INVENTORY_ENTITY,id);
    if(!row)return null;
    return assertOwner(createWoodInventoryItem(row));
  }

  async function update(id,changes={}){
    const current=await get(id);
    if(!current)throw new Error('WOOD_INVENTORY_NOT_FOUND');
    const next=updateWoodInventoryItem(current,{...changes,updatedAt:now()});
    return queue.enqueue(WOOD_INVENTORY_ENTITY,next,'update');
  }

  async function archive(id){
    const current=await get(id);
    if(!current)throw new Error('WOOD_INVENTORY_NOT_FOUND');
    const next=archiveWoodInventoryItem(current,{now:now()});
    return queue.enqueue(WOOD_INVENTORY_ENTITY,next,'update');
  }

  async function restore(id){
    const current=await get(id);
    if(!current)throw new Error('WOOD_INVENTORY_NOT_FOUND');
    const next=restoreWoodInventoryItem(current,{now:now()});
    return queue.enqueue(WOOD_INVENTORY_ENTITY,next,'update');
  }

  async function list({includeArchived=false}={}){
    const rows=await repository.list(WOOD_INVENTORY_ENTITY);
    return Object.freeze(rows
      .map(row=>createWoodInventoryItem(row))
      .filter(item=>item.userId===owner)
      .filter(item=>includeArchived||!item.archivedAt)
      .sort((a,b)=>String(a.customName||a.catalogueKey).localeCompare(String(b.customName||b.catalogueKey))));
  }

  return Object.freeze({create,get,update,archive,restore,list});
}
